/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { observable, action } from "mobx";
import { DEFAULT_PAGE_SIZE, DEFAULT_PAGE_FORMAT } from "constants/constants";

class DCAPIStore {
  @observable isFirstDCAPIRenditionLoaded;
  @observable DCAPIRenditionSize;
  @observable DCAPIRenditionFormat;

  constructor() {
    this.init();
  }

  initStore(docApi, stores) {
    if (docApi) {
      this.docApi = docApi;
    }
    if (stores) {
      this.stores = stores;
    }
  }

  @action
  init() {
    this.isFirstDCAPIRenditionLoaded = false;
    this.DCAPIRenditionSize = DEFAULT_PAGE_SIZE;
    this.DCAPIRenditionFormat = DEFAULT_PAGE_FORMAT;
  }

  @action
  setFirstDCAPIRenditionStatus(value = false) {
    this.isFirstDCAPIRenditionLoaded = value;
  }

  @action
  setDCAPIRenditionSize(value) {
    this.DCAPIRenditionSize = value;
  }

  @action
  setDCAPIRenditionFormat(value) {
    this.DCAPIRenditionFormat = value;
  }
}

export { DCAPIStore };
